import type { ReactElement } from 'react';
import * as React from 'react';
import { Button, Tooltip } from '@hotjar/hotsauce';
import { useTranslationWithPrefix } from '@hotjar/translations';

interface DisableMfaButtonProps {
  isVisible: boolean;
  isMfaEnforced: boolean;
  onClick: () => void;
}

export const DisableMfaButton = ({
  onClick,
  isMfaEnforced,
  isVisible,
}: DisableMfaButtonProps): ReactElement | null => {
  const { t } = useTranslationWithPrefix('mfa:disable-mfa-button');

  if (!isVisible) {
    return null;
  }

  const btn = (
    <Button isDisabled={isMfaEnforced} kind="secondary" onClick={onClick}>
      {t('button-text')}
    </Button>
  );

  if (isMfaEnforced) {
    return (
      <Tooltip text={t('tooltip-text')}>
        <span data-testid="enforce-mfa-button">{btn}</span>
      </Tooltip>
    );
  }

  return btn;
};
